module.exports = __webpack_public_path__ + "img/drag_indicator.287d1295.svg";